import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectRouteData } from '../../models/redirect-route-data';


@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.scss'
})
export class RedirectComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {
   
  }

  ngOnInit(): void {
    let routeData: RedirectRouteData;

    routeData = this.route.snapshot.data as RedirectRouteData;

        if (routeData.target && routeData.target == '_blank') {
          window.open(routeData.redirectTo, '_blank');
        }
        else {
          window.location.href = routeData.redirectTo;
        }
  }
}


